export default __webpack_public_path__ + "static/polaroid-dc6cc5dc9a92f23812bb1725da50d3fe.png";